import React from 'react';
import './Skeleton.css';

const PageSkeleton = () => (
  <div className="page-skeleton" role="status" aria-label="Cargando página">
    <span className="page-skeleton__sr-only">Cargando página</span>
    <div className="skeleton-base page-skeleton__title" />
    <div className="page-skeleton__content" aria-hidden="true">
      <div className="skeleton-base page-skeleton__line page-skeleton__line--wide" />
      <div className="skeleton-base page-skeleton__line" />
      <div className="skeleton-base page-skeleton__panel" />
    </div>
  </div>
);

export default PageSkeleton;
